import { useState, useContext } from 'react'
import { Editor } from "react-draft-wysiwyg"
import { EditorState, ContentState, convertFromHTML, convertToRaw } from "draft-js"
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css"
import { Modal, Input, Switch, Select, Option } from '../ui_new'
import { UserPlus, PlusCircle, Scales } from '../../assets/icons'
import draftToHtml from "draftjs-to-html"

import {
  UserContext,
  NotificationContext,
  LoaderContext,
  DocumentsContext,
} from '../../context'
import { useSingleDocumentActions } from '../../hooks'
import { validateEmail } from '../../helpers/validate'
import { add_document_event } from '../../services/firestore'
import { Delete, Gavel, Lock, People, Person, Replay, Settings, Save, Close, CheckCircle } from '@mui/icons-material'
import { useEffect } from 'react'
import moment from 'moment'


  const DEFAULT_ROLE = 'other'

const SingleDocumentShareV2 = ({
  onClose,
  singleDoc,
  documentId,
  contacts,
}) => {
  const { shareDocumentWithContact, removeDocumentShareWithContact } = useSingleDocumentActions()
  const { setShowGlobalResponseLoader, setGlobalResponseLoaderText } =
    useContext(LoaderContext)
  const { setNotification } = useContext(NotificationContext)
  const { user } = useContext(UserContext)
  const { updateDocument } = useContext(DocumentsContext)
  // const [recipients, setRecipients] = useState([
  //     {
  //         value: '',
  //         id: `recipient-${uuidv4()}`,
  //     },
  // ])
  // const [clientInput, setClientInput] = useState('')
  // const [clientRecipients, setClientRecipients] = useState([])
  // const [notaryEmail, setNotaryEmail] = useState('')
  // const [notaryRecipients, setNotaryRecipients] = useState([])
  // const [lawyerEmail, setLawyerEmail] = useState('')
  // const [lawyerRecipients, setLawyerRecipients] = useState([])
  // const [otherEmail, setOtherEmail] = useState('')
  // const [otherRecipients, setOtherRecipients] = useState([])

  const [filteredContacts, setFilteredContacts] = useState([])

  // const [selectedContact, setSelectedContact] = useState(null)
  const [selectedContactHash, setSelectedContactHash] = useState(null)
  const [email, setEmail] = useState('')
  const [firstname, setFirstname] = useState('')
  const [lastname, setLastname] = useState('')
  const [access, setAccess] = useState('read') // read, comment, edit
  const [duration, setDuration] = useState(7) // days

  const [role, setRole] = useState(DEFAULT_ROLE) // notary, lawyer, other

  const [subject, setSubject] = useState('Nouveau document disponible')
  const [message, setMessage] = useState(
    `<p>Bonjour &lt;Prénom&gt; &lt;Nom&gt;,</p>
        <p>Vous trouverez ci-dessous le lien pour relire le document &lt;Nom du document&gt;.</p>
        <p><b>&lt;LIEN VERS LE DOCUMENT&gt;</b></p>
        <p>Nous restons à votre écoute pour toutes corrections et/ou modifications éventuelles.</p>
        <p>Cordialement,</p>
        <p>&lt;Prénom utilisateur&gt; &lt;Nom utilisateur&gt;</p>
        <p>&lt;email utilisateur&gt; / &lt;phone utilisateur&gt;</p>
        <p>&lt;Nom agence&gt;</p>
        <p>&lt;Adresse agence&gt; &lt;Code postal agence&gt; &lt;Ville agence&gt;</p>`
  )

  const [shareAttachments, setShareAttachments] = useState(false)
  const [applyWatermark, setApplyWatermark] = useState(false)

  const [selectedShare, setSelectedShare] = useState(null)

  useEffect(() => {
    const filtered = contacts.filter(contact => {
      return contact.firstname && contact.lastname
    })
    setFilteredContacts([
      ...filtered,
    ])
  }, [contacts])

  useEffect(() => {
    if (singleDoc) {
      setShareAttachments(singleDoc.shareSettings?.shareAttachments || false)
      setApplyWatermark(singleDoc.shareSettings?.applyWatermark || false)
    }
  }, [singleDoc])

  // On submit
  const handleSubmit = async (e, action) => {
    e.preventDefault()

    if(selectedShare === null) {
      // just update share settings
      try {
        setShowGlobalResponseLoader(true)
        setGlobalResponseLoaderText('Enregistrement des paramètres de partage')

        await updateDocument({ shareSettings: {
          shareAttachments: shareAttachments,
          applyWatermark: applyWatermark
        } }, { id: documentId })
        setNotification({
          msg: 'Paramètres de partage enregistrés',
          type: 'success',
        })
      } catch (err) {
        console.error(err)
        setNotification({
          msg: 'Une erreur est survenue lors de l\'enregistrement des paramètres de partage',
          type: 'danger',
        })
      } finally {
        setShowGlobalResponseLoader(false)
        setGlobalResponseLoaderText('')
        onClose()
      }
      return 
    }

    const messageHtml = draftToHtml(convertToRaw(editorState.getCurrentContent()))

    if (!subject.trim()) {
      return setNotification({
        msg: 'L\'objet de l\'email ne peut pas être vide',
        type: 'danger',
      })
    }
    if (!messageHtml.trim()) {
      return setNotification({
        msg: 'Le message ne peut pas être vide',
        type: 'danger',
      })
    }
    if (!email.trim() || !validateEmail(email)) {
      return setNotification({
        msg: 'Veuillez ajouter un destinataire valide',
        type: 'danger',
      })
    }
    if (!selectedShare.shared_at && selectedShare.type === 'client' && !selectedContactHash) {
      return setNotification({
        msg: 'Veuillez sélectionner un contact valide',
        type: 'danger',
      })
    }

    action = action ?? (selectedShare.shared_at ? 'update-share' : 'new-share')
    try {
      // update existing share or create new share
      // if new-share, validate if contact already has access
      const existingShare = (singleDoc.sharedWith || []).find(share => share.email.toLowerCase() === email.trim().toLowerCase())
      if (action === 'new-share' && existingShare) {
        return setNotification({
          msg: 'Ce contact possède déjà un accès à ce document. Veuillez modifier le partage existant ou utiliser une autre adresse email.',
          type: 'danger',
        })
      }
      setShowGlobalResponseLoader(true)
      const loadingMessage = 
        action === 'resend-email' ? 'Régénération de l\'email' : 
        action === 'new-password' ? 'Génération d\'un nouveau mot de passe' : 
        action === 'update-share' ? 'Mise à jour du partage' :
        action === 'new-share' ? 'Partage du document' :
        'Partage du document'

      setGlobalResponseLoaderText(loadingMessage)

      setMessage(messageHtml)
      let data = {
        message: messageHtml,
        sender: user,
        subject: subject.trim(),
        recipient: {
          firstname: firstname.trim(),
          lastname: lastname.trim(),
          email: email.trim(),
          role: role.trim(),
          access: access,
          duration: duration,
        },
        action: action,
      }
      await shareDocumentWithContact(documentId, data)
      if(!action) {
        await add_document_event(documentId, {
          type: 'email_share',
          recipient: {
            firstname: firstname.trim(),
            lastname: lastname.trim(),
            email: email.trim(),
            role: role.trim(),
            access: access,
            duration: duration,
            sharedBy: {
              id: `${user.id}`,
              firstname: user.firstname,
              lastname: user.lastname,
              agency_id: `${user.agency?.manufacturers_id || user.agency?.id}`,
            }
          },
          values: singleDoc.values,
          content_changes: singleDoc.content_changes,
        })
      }
      // onClose()
      // setSelectedContact(null)
      setSelectedContactHash(null)
      setEmail('')
      setFirstname('')
      setLastname('')
      setAccess('read')
      setDuration(7)
      setRole(DEFAULT_ROLE)
      setSubject('Nouveau document disponible')
      setMessage(
        `<p>Bonjour &lt;Prénom&gt; &lt;Nom&gt;,</p>
        <p>Vous trouverez ci-dessous le lien pour relire le document &lt;Nom du document&gt;.</p>
        <p><b>&lt;LIEN VERS LE DOCUMENT&gt;</b></p>
        <p>Nous restons à votre écoute pour toutes corrections et/ou modifications éventuelles.</p>
        <p>Cordialement,</p>
        <p>&lt;Prénom utilisateur&gt; &lt;Nom utilisateur&gt;</p>
        <p>&lt;email utilisateur&gt; / &lt;phone utilisateur&gt;</p>
        <p>&lt;Nom agence&gt;</p>
        <p>&lt;Adresse agence&gt; &lt;Code postal agence&gt; &lt;Ville agence&gt;</p>`
      )
      setSelectedShare(null)
      const notificationMessage = 
        action === 'resend-email' ? 'L\'email a été renvoyé avec succès' : 
        action === 'new-password' ? 'Un nouveau mot de passe a été généré avec succès' : 
        action === 'update-share' ? 'Le partage a été mis à jour avec succès' :
        action === 'new-share' ? 'Le document a été partagé avec succès' :
        'Action réalisée avec succès'
      setNotification({
        msg: notificationMessage,
        type: 'success',
      })
    } catch (err) {
      console.error(err)
      setNotification({
        msg: 'Une erreur est survenue lors du partage du document',
        type: 'danger',
      })
    } finally {
      setShowGlobalResponseLoader(false)
      setGlobalResponseLoaderText('')
    }
  }
  const blocksFromHTML = convertFromHTML(message)

  const [editorState, setEditorState] = useState(EditorState.createWithContent(
    ContentState.createFromBlockArray(
      blocksFromHTML.contentBlocks,
      blocksFromHTML.entityMap
    )
  ))

  const onEditorStateChange = (editorState) => {
    setEditorState(editorState)
  }

  const handleEditShare = (contact) => {
    setSelectedShare({
      ...contact,
      firstname: contact.firstname || '',
      lastname: contact.lastname || '',
      email: contact.email || '',
      role: contact.role || 'other',
      type: contact.role || 'other'
    })
    setFirstname(contact.firstname || '')
    setLastname(contact.lastname || '')
    setEmail(contact.email || '')
    setRole(contact.role || DEFAULT_ROLE)
    setAccess(contact.access || 'read')
    setDuration(contact.duration || 7)
  }

  const handleRemoveShare = async (contact) => {
    if (window.confirm(`Êtes-vous sûr de vouloir supprimer le partage avec ${contact.firstname} ${contact.lastname} (${contact.email}) ?`)) {
      // Supprimer le partage
      setShowGlobalResponseLoader(true)
      setGlobalResponseLoaderText('Suppression du partage')
      await removeDocumentShareWithContact(documentId, contact)
      setNotification({
        msg: `Le partage avec ${contact.email} a été supprimé`,
        type: 'success',
      })
      setShowGlobalResponseLoader(false)
      setGlobalResponseLoaderText('')
      setSelectedShare(null)
      setFirstname('')
      setLastname('')
      setEmail('')
      setRole('other')
      setAccess('read')
      setDuration(7)
    }
  }

  const promptAddShare = () => {
    setSelectedShare({
      type: null,
      role: null,
    })
  }

  const handleSelectAddShareType = (type) => {
    setSelectedShare((share) => ({
      ...share,
      firstname: '',
      lastname: '',
      email: '',
      type: type,
      role: type === 'client' ? 'client' : 'other',
    }))
    setFirstname('')
    setLastname('')
    setEmail('')
  }

  const handleCancel = () => {
    if (selectedShare !== null) {
      setSelectedShare(null)
    } else {
      onClose()
    }
  }

  const labelForAccess = (access) => {
    switch (access) {
      case 'read':
        return 'Lecteur'
      case 'comment':
        return 'Commentateur'
      case 'edit':
        return 'Modificateur'
      default:
        return 'Accès inconnu'
    }
  }

  const labelForRole = (role) => {
    switch (role) {
      case 'client':
        return 'Client'
      case 'notary':
        return 'Notaire'
      case 'lawyer':
        return 'Avocat'
      case 'other':
      default:
        return 'Autres'
    }
  }

  const iconForRole = (role) => {
    switch (role) {
      case 'client':
        return <Person className="icon" />
      case 'notary':
        return <Gavel className="icon" />
      case 'lawyer':
        return <Scales className="icon" />
      case 'other':
      default:
        return <People className="icon" />
    }
  }

  const handleSelectContact = (hash) => {
    const contact = filteredContacts.find(c => contactHash(c) === hash)
    if (contact) {
      setFirstname(contact.firstname || '')
      setLastname(contact.lastname || '')
      setEmail(contact.email)
      setRole('client')
      setSelectedContactHash(hash)
    } else {
      setFirstname('')
      setLastname('')
      setEmail(email)
      setRole('other')
      setSelectedContactHash(null)
    }
  }

  const contactHash = (contact) => {
    return `${(contact.firstname || '').toLowerCase()}-${(contact.lastname || '').toLowerCase()}-${(contact.email || '').toLowerCase()}`.replace(/\s+/g, '-').replace(/[^a-z0-9-]/g, '')
  }

  return (
    <>
      <Modal onClose={onClose} className="modal-v2 modal-v2--mid-large">
        <div className="modal-v2__heading">
          <h2>{selectedShare === null ? 'Partager' : !selectedShare.shared_at ? 'Ajouter un accès' : `Partage à : ${selectedShare.firstname} ${selectedShare.lastname}`}</h2>
          <div className="buttons-row desktop">
            <button
              className="btn btn--medium btn--primary-light btn--with-icon"
              onClick={handleCancel}
            >
              <Close />
              Fermer
            </button>
            {(selectedShare === null || selectedShare.type !== null) && (
              <button className="btn btn--medium btn--success btn--with-icon" onClick={handleSubmit}>
                <CheckCircle />
                <span>
                  { selectedShare === null ? 'Valider' : 'Enregistrer' }
                </span>
              </button>
            )}
          </div>
          <div className="buttons-row mobile">
            <button className="btn btn--primary-light btn--with-icon" onClick={onClose}>
              <Close />
              Fermer
            </button>
          </div>
        </div>

        <div className="modal-v2__body">
          {selectedShare === null && (
            <div className="share-list">
              <h3 className="share-list__title">Qui possède l'accès ?</h3>
              {(singleDoc.sharedWith || []).length === 0 && (
                <div className="no-shares">
                  <span>Aucun destinataire ajouté.</span>
                </div>
              )}
              <div className="share-list__contacts mt-24 mb-24">
                {(singleDoc.sharedWith || []).map((contact, index) => (
                  <div className="share-list__contact" key={index}>
                    <div className="share-list__contact-avatar">
                      <span className="avatar">
                        {contact.firstname && contact.lastname
                          ? `${contact.firstname[0]}${contact.lastname[0]}`
                          : contact.email[0]}
                      </span>
                    </div>
                    <div className="share-list__contact-info flex-grow">
                      <div className='flex flex-row items-center gap-2'>
                        <span className="share-list__contact-name">
                          {contact.firstname} {contact.lastname.toUpperCase()}
                        </span>
                        <span className={`share-list__contact-role ${contact.role}`}>
                          {iconForRole(contact.role)}
                          {labelForRole(contact.role)}
                        </span>
                      </div>
                      <span className="share-list__contact-access">
                        {labelForAccess(contact.access)} - {(moment(contact.expires).diff(moment(), 'days'))} jours restants
                      </span>
                    </div>
                    <div className="share-list__contact-actions flex flex-row items-center gap-2">
                      <button
                        className="btn btn--small btn--transparent-primary btn--primary btn--square"
                        onClick={() => handleEditShare(contact)}
                      >
                        <Settings />
                      </button>
                      <button
                        className="btn btn--small btn--transparent btn--danger btn--square"
                        onClick={() => handleRemoveShare(contact)}
                      >
                        <Delete />
                      </button>
                    </div>
                  </div>
                ))}
              </div>
              <button
                className="btn btn--primary-light btn--with-icon btn--medium btn--full-width"
                onClick={promptAddShare}
              >
                <UserPlus />
                Ajouter un accès
              </button>
              <div className="share-settings mt-24">
                <h4 className="share-settings__title">Personnalisation du partage</h4>
                <div className="flex flex-row items-center gap-2 mt-4">
                  <div className="flex flex-row items-center gap-8 flex-grow">
                    <Switch
                      checked={shareAttachments}
                      onChange={() => setShareAttachments(!shareAttachments)}
                    />
                    <span className='switch-label'>Joindre les documents annexés</span>
                  </div>
                  <div className="flex flex-row items-center gap-8 flex-grow">
                    <Switch
                      checked={applyWatermark}
                      onChange={() => setApplyWatermark(!applyWatermark)}
                    />
                    <span className='switch-label'>Appliquer le filigrane "projet"</span>
                  </div>
                </div>
              </div>
            </div>
          )}
          {/* contact type selector */}
          {selectedShare !== null && selectedShare.type === null && (
            // display a selector for share type
            // options: "Un client", "Autres"
            // options are displayed as blocks next to each other
            // each block has a title and a button: "Créer un accès client" or "Créer un accès"

            <div className="share-type-selector flex flex-row gap-2 pb-4">
              <div
                className="share-type-selector__option"
              >
                <h3>Un client</h3>
                <button
                  className="btn btn--secondary-outline btn--with-icon btn--medium btn--full-width"
                  onClick={() => handleSelectAddShareType('client')}
                >
                  <PlusCircle />
                  Créer un accès client
                </button>
              </div>
              <div
                className="share-type-selector__option"
              >
                <h3>Autres</h3>
                <button
                  className="btn btn--secondary-outline btn--with-icon btn--medium btn--full-width"
                  onClick={() => handleSelectAddShareType('other')}
                >
                  <PlusCircle />
                  Créer un accès
                </button>
              </div>
            </div>
          )}

          {/* contact details and message form */}
          {selectedShare !== null && selectedShare.type !== null && (
            <div
              className="flex flex-col w-full md:flex-row flex-wrap modal-v2__body__inner"
            >
              {selectedShare.type !== 'client' && !selectedShare.shared_at && (<>
                <div className="share-form__field-wrapper w-full md:w-1/2 mb-6 md:pr-4">
                  <div className="input-wrapper">
                    <Input
                      value={lastname}
                      type="string"
                      onChange={(e) => setLastname(e.target.value)}
                      className={lastname ? 'not-empty' : ''}
                      label={'Nom'}
                      required />
                  </div>
                </div>
                <div className="share-form__field-wrapper w-full md:w-1/2 mb-6">
                  <div className="input-wrapper">
                    <Input
                      value={firstname}
                      type="string"
                      onChange={(e) => setFirstname(e.target.value)}
                      className={firstname ? 'not-empty' : ''}
                      label={'Prénom'}
                      required />
                  </div>
                </div>
              </>)}
              {selectedShare.type === 'client' && !selectedShare.shared_at && (
                <div className="share-form__field-wrapper w-full mb-6">
                  <span className="form-label">Sélectionnez</span>
                  <Select
                    className="w-full"
                    label=""
                    selected={selectedContactHash}
                    onChange={(hash) => handleSelectContact(hash)}
                    disabled={selectedShare?.shared_at || filteredContacts.length === 0}
                  >
                    {filteredContacts.length === 0 && <Option value="" selected={true}>Aucun contact trouvé</Option>}
                    {filteredContacts.length > 0 && <Option value="" selected={selectedContactHash === null} disabled={true}>Sélectionnez un contact</Option>}
                    {filteredContacts.map((contact, index) => (
                      <Option key={index} value={contactHash(contact)} selected={selectedContactHash === contactHash(contact)}>
                        {`${contact.firstname} ${contact.lastname}`}
                      </Option>
                    ))}
                  </Select>
                </div>
              )}
              <div
                className={`share-form__field-wrapper w-full mb-6 ${selectedShare.type !== 'client' && selectedShare.shared_at ? 'md:w-1/2 md:pr-4' : ''}`}
              >
                <Input
                  label="Adresse mail"
                  value={email}
                  onChange={(e) => {
                    setEmail(e.target.value)
                  }}
                  disabled={selectedShare?.shared_at}
                  tooltip={selectedShare?.shared_at ? "Impossible de modifier l'adresse e-mail du destinataire. Supprimer l'accès et partager à nouveau." : ''}
                  required
                />
              </div>
              {selectedShare.type !== 'client' && (
                <div className={`share-form__field-wrapper w-full mb-6 ${selectedShare.shared_at ? 'md:w-1/2' : ''}`}>
                  <label className="form-label">Rôle</label>
                  <Select
                    className="w-full"
                    label=""
                    selected={role}
                    onChange={(value) => setRole(value)}
                  >
                    <Option value="lawyer" selected={role === "lawyer"}>Avocat</Option>
                    <Option value="notary" selected={role === "notary"}>Notaire</Option>
                    <Option value="other" selected={role === "other"}>Autre</Option>
                  </Select>
                </div>
              )}

              <div className="share-form__field-wrapper w-full md:w-1/2 mb-6 md:pr-4">
                <label className="form-label">Droits de partage</label>
                <Select
                  className="w-full"
                  label=""
                  selected={access}
                  onChange={(value) => setAccess(value)}
                >
                  <Option value="read" selected={access === "read"}>Lecture</Option>
                  <Option value="comment" selected={access === "comment"}>Commentaire</Option>
                  <Option value="edit" selected={access === "edit"}>Modification</Option>
                </Select>
              </div>
              <div className="share-form__field-wrapper w-full md:w-1/2 mb-6">
                <label className="form-label">Durée de mise à disposition du document</label>
                <Select
                  className="w-full"
                  label=""
                  selected={`${duration}`}
                  onChange={(value) => setDuration(parseInt(value))}
                >
                  <Option value="7" selected={duration === "7"}>7 jours</Option>
                  <Option value="14" selected={duration === "14"}>14 jours</Option>
                  <Option value="30" selected={duration === "30"}>30 jours</Option>
                </Select>
              </div>
              <div className="share-form__field-wrapper w-full mb-6">
                <Input
                  label="Objet de l’email"
                  value={subject}
                  onChange={(e) =>
                    setSubject(e.target.value)
                  }
                />
              </div>
              <div className="share-form__field-wrapper w-full pb-4">
                <Editor
                  editorState={editorState}
                  toolbarClassName="toolbarClassName"
                  wrapperClassName="wrapperClassName"
                  editorClassName="editorClassName"
                  onEditorStateChange={onEditorStateChange}

                  toolbar={{
                    options: [
                      "history",
                      "inline",
                      "list",
                      "textAlign",
                      "remove"
                    ],
                    history: {
                      undo: { icon: '/images/undo.png', className: "editor-icon" },
                      redo: { icon: '/images/redo.png', className: "editor-icon" }
                    },
                    inline: {
                      inDropdown: false,
                      options: [
                        "bold",
                        "italic",
                      ],
                      bold: { icon: "/images/editor-icons/bold.svg", className: "editor-icon" },
                      italic: { icon: "/images/editor-icons/italic.svg", className: "editor-icon" },
                    },
                    textAlign: {
                      inDropdown: false,
                      options: ["left", "center", "right", "justify"],
                      left: { icon: "/images/editor-icons/align-left.svg", className: "editor-icon" },
                      center: { icon: "/images/editor-icons/align-center.svg", className: "editor-icon" },
                      right: { icon: "/images/editor-icons/align-right.svg", className: "editor-icon" },
                      justify: { icon: "/images/editor-icons/align-justify.svg", className: "editor-icon" },
                    },
                    blockType: {
                      inDropdown: true,
                      options: [
                        "Normal",
                        "H1",
                        "H2",
                        "H3",
                        "H4",
                        "H5",
                        "H6",
                        "Blockquote",
                        "Code"
                      ]
                    },
                    list: {
                      inDropdown: false,
                      options: ["unordered", "ordered", "indent", "outdent"],
                      unordered: { icon: "/images/editor-icons/bullet-list.svg", className: "editor-icon" },
                      ordered: { icon: "/images/editor-icons/ordered-list.svg", className: "editor-icon" },
                      indent: { icon: "/images/editor-icons/indent.svg", className: "editor-icon" },
                      outdent: { icon: "/images/editor-icons/outdent.svg", className: "editor-icon" },
                    },
                    remove: { icon: "/images/editor-icons/clear-format.svg", className: "editor-icon" }
                  }}
                />
              </div>
              {selectedShare.shared_at && (<div className='w-full'>
                <div className='flex flex-row flex-wrap pb-4 gap-4'>
                  <button className="btn btn--white btn--with-icon btn--border-primary btn--border-radius-sm flex-grow" onClick={(e) => handleSubmit(e, 'resend-email')}>
                    <Replay />
                    Régénérer un mail d'accès
                  </button>
                  <button className="btn btn--primary-light btn--with-icon btn--border-radius-sm flex-grow" onClick={(e) => handleSubmit(e, 'new-password')}>
                    <Lock />
                    Générer un nouveau mot de passe
                  </button>
                </div>
                <button className="btn btn--danger btn--border-radius-sm btn--with-icon w-full" onClick={() => handleRemoveShare(selectedShare)}>
                  <Delete />
                  <span>
                    Supprimer le partage
                  </span>
                </button>
              </div>)}
            </div>
          )}
        </div>
        <div className="bottom-bar bottom-bar__mobile bottom-bar--sticky">
          <button className="btn btn--success btn--large btn--with-icon w-full" onClick={handleSubmit}>
            <Save />
            <span>
              { selectedShare === null ? 'Valider' : 'Enregistrer' }
            </span>
          </button>
        </div>
      </Modal>
    </>
  )
}

export default SingleDocumentShareV2
